import { motion, AnimatePresence } from 'framer-motion';

type SuccessPopupProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
};

export default function SuccessPopup({ isOpen, onClose, title, message }: SuccessPopupProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center"
          >
            {/* Popup */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="bg-white rounded-2xl p-8 shadow-2xl z-50 max-w-md w-full mx-4"
              onClick={e => e.stopPropagation()}
            >
              <h2 className="text-2xl font-bold text-primary mb-4 text-center">
                {title}
              </h2>
              <p className="text-text/70 mb-6 text-center">
                {message}
              </p>
              <button
                onClick={onClose}
                className="w-full px-6 py-3 bg-primary text-white rounded-lg 
                  hover:bg-primary-light transition-all duration-300 
                  font-medium"
              >
                Close
              </button>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
} 